import { API, Auth } from "aws-amplify";
import { takeEvery, call, put, all } from "redux-saga/effects";
import * as languagesTypes from "../../constants/LanguagesActionTypes";
import _ from "lodash";

function* getLanguages({ clinic, date }) {
  try {
    let session = yield Auth.currentSession();
    let token = session.getIdToken().getJwtToken();
    const languages = yield API.get("multimedia-checklist", `/shoot/${clinic}/${date}/language`, {
      headers: {
        Authorization: token
      }
    });
    console.log(languages);
    yield put({
      type: languagesTypes.LANGUAGES_FETCHED,
      languages
    });
  } catch (err) {
    console.log(err);
    yield put({
      type: languagesTypes.LANGUAGES_FAILED
    });
  }
}

function* watchGetLanguages() {
  yield takeEvery(languagesTypes.LANGUAGES_FETCHING, getLanguages);
}

export default {
  watchGetLanguages
};
